const handleResponse = (response) => {
  if (!response.ok) {
    return response.json().then((data) => {
      throw new Error(data.error || 'Request failed');
    });
  }
  return response.json();
};

// Loads the builder response behind a survey, keyed by the survey uuid, so the
// dynamic flow renders while logged out (email/SMS links) just like the legacy
// hardcoded surveys.
export const getConversationSurveyResponse = (conversationSurveyId) => {
  return fetch(`/api/v1/conversation_surveys/${conversationSurveyId}/questionnaire_response`, {
    headers: { 'Content-Type': 'application/json' },
  }).then(handleResponse);
};

// Records an answer on the builder response behind a survey, keyed by the
// survey uuid, so answering works while logged out.
export const answerConversationSurveyResponse = (conversationSurveyId, questionId, value) => {
  return fetch(`/api/v1/conversation_surveys/${conversationSurveyId}/answer_questionnaire_response`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ question_id: questionId, value }),
  }).then(handleResponse);
};

export const getConversationSurvey = (conversationSurveyId, successCallback) => {
  return fetch(`/api/v1/conversation_surveys/${conversationSurveyId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw response.json();
      }
      return response.json();
    })
    .then(successCallback)
    .catch((error) => {
      console.error('Error getting conversation survey:', error);
    });
};

export const setConversationSurveySource = (conversationSurveyId, completionSource) => {
  return fetch(`/api/v1/conversation_surveys/${conversationSurveyId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ completion_source: completionSource }),
  })
    .then((response) => {
      if (!response.ok) {
        throw response.json();
      }
      return response.json();
    })
    .catch((error) => {
      console.error('Error setting conversation survey source:', error);
    });
};

export const updateConversationSurvey = (conversationSurveyId, params, successCallback) => {
  return fetch(`/api/v1/conversation_surveys/${conversationSurveyId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response.json();
      }
      return response.json();
    })
    .then((data) => {
      if (successCallback) {
        successCallback(data);
      }
    })
    .catch((error) => {
      console.error('Error updating conversation survey:', error);
      alert(
        'Oops! Something went wrong. Please try again or contact support if this persists at support@patientpartner.com.'
      );
    });
};
